/* Creazione del check-button per visible/hidden layer per l'aggiunta da url */
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {addLayerUrl} from '../redux'
import { connect } from 'react-redux';

function CheckBoxAddLayer(props) {
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
        setChecked(event.target.checked);
        props.addLayerUrl({url:props.dataLayer,name:props.value,check:event.target.checked})
    // inProps.callback(event.target.checked);
  };

  return (
    <div className={"checkAddLayer"}>
        <FormControlLabel control={
            <Checkbox
            size={"small"}
            checked={checked}
            onChange={handleChange}
            color="primary"
            inputProps={{ 'aria-label': 'primary checkbox' }}
        />}/>
    </div>)}
    const mapStateToProps = state => {
        return {
            layerUrl: state.layerUrl
        }
      }
      const mapDispatchToProps = dispatch => {
        return {
          addLayerUrl: (layerUrl) => dispatch(addLayerUrl(layerUrl))
        }
    }

    export default connect(mapStateToProps,mapDispatchToProps)(CheckBoxAddLayer)